import React from 'react'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import Detail from '../elements/Detail'
import PendingConnectionDetails from '../components/PendingConnectionDetails'
import PendingDetails from '../components/PendingDetails'

const PendingConnectionBroadband = (props) => {
    const types = {
        nbn: 'nbn&trade;',
        adsl: 'ADSL',
        fibre: 'fibre'
    }

    const icons = {
        orderReceived: 'icon-order-received.svg',
        expectedActivation: 'icon-expected-activation.svg',
        technicianAppointment: 'icon-tech-appointment.svg',
        modemDispatched: 'icon-modem-dispatch.svg',
        serviceActive: 'icon-service-active.svg',
        informationNeeded: 'icon-info-needed.svg'
    }

    const serviceDetails = [
        { title: 'Service no.', value: props.serviceDetails.serviceNo },
        { title: 'Service type', value: props.serviceDetails.serviceType },
        { title: 'Service class', value: props.serviceDetails.serviceClass },
        { title: 'Data', value: props.serviceDetails.data },
        { title: 'Speed tier', value: props.serviceDetails.planTitle ? props.serviceDetails.planTitle : props.serviceDetails.speedTier }
    ]

    return (
        <div className='pending-connection module'>
            <Heading title={`STATUS: My new ${types[props.serviceDetails.type]} connection`}>
                <div className='col-md-7 col-12 mt-md-0 mt-2 d-flex align-items-center justify-content-md-end'>{props.serviceDetails.address}</div>
            </Heading>
            <ModuleWithLoader isLoaded>
                <div className='row mx-3 mt-3 p-3 p-md-4 bg-lightgrey no-gutters'>
                    <div className='col-12 d-flex justify-content-center text-center flex-wrap'>
                        <PendingDetails items={serviceDetails} />
                    </div>
                </div>
                {props.status.map((item, key) => {
                    return (
                        <PendingConnectionDetails
                            key={key}
                            icon={`/images/pending-connections/${icons[item.type]}`}
                            title={item.title}
                            date={item.date}
                            items={item.items}
                        />
                    )
                })}
            </ModuleWithLoader>
        </div>
    )
}

export default PendingConnectionBroadband



// WEBPACK FOOTER //
// ./resources/js/modules/PendingConnectionBroadband.js